import { Grid, Stack } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { InfoCard, SlidingPanelContent } from 'core/components';
import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { IInfoCardLine } from 'core/types';
import { formatDate } from 'core/utils';
import { IExternalPricesResponse } from 'parts/types';
import { PricingHelper } from 'pricing/helpers';
import { Direction, Level } from 'theme/enums';

import { VendorPriceCard } from '../PartPriceCards';

interface IProps {
  externalPricing?: IExternalPricesResponse | null;
  fullWidth?: boolean;
}

const sectionGridSizing = { xs: 12, md: 6 };

const formatPricing = (amount?: number | null, uom?: string) =>
  amount != null ? PricingHelper.formatPricingPerUom(amount, uom) : DEFAULT_PLACEHOLDER;

const formatText = (value?: string | null) => value || DEFAULT_PLACEHOLDER;

const formatEndDate = (date?: string | null) => (date ? formatDate(date) : DEFAULT_PLACEHOLDER);

export const AlternatePrices = ({ externalPricing, fullWidth }: IProps) => {
  const { t } = useTranslation();

  const uom = externalPricing?.uom;

  const priceItems: IInfoCardLine[] = [
    { label: t('labelPrice'), value: formatPricing(externalPricing?.price, uom) },
    {
      label: t('labelExternalSellPriceEndDate'),
      value: formatEndDate(externalPricing?.externalSellPriceEndDate),
    },
    {
      label: t('labelExternalSellPriceSource'),
      value: formatText(externalPricing?.externalSellPriceSource),
    },
    {
      label: t('labelExternalSellPriceSourceName'),
      value: formatText(externalPricing?.externalSellPriceSourceName),
    },
  ];

  return (
    <SlidingPanelContent title={t('titlePrices')} fullWidth={fullWidth} scrollableContent>
      <Stack>
        <Stack direction={Direction.ROW} sx={{ flexWrap: 'wrap', gap: 2 }}>
          <VendorPriceCard
            groupName={t('labelPrice')}
            listPrice={externalPricing?.price}
            uom={uom}
            highlighted
          />
        </Stack>

        <Grid container spacing={3} sx={{ margin: '0 -10px !important' }}>
          <Grid {...sectionGridSizing}>
            <InfoCard title={t('labelPrice')} titleLevel={Level.TITLE_MD} items={priceItems} />
          </Grid>
        </Grid>
      </Stack>
    </SlidingPanelContent>
  );
};
